import MediaQueryProvider from './MediaQueryProvider';

export default MediaQueryProvider;
